import { FC, useState } from 'react';
import { WhiteLogo } from '@/assets/logos';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faCircleUser,
  faGear,
  faSignOut,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { PagesPaths } from '@/enums';
import { isAuthenticated } from '@/utils/auth';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthContext } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from 'primereact/confirmdialog';

import { DropdownField } from '@/components';
import { optionTemplate } from '../Header/Header';
import { MobileMenu } from '../Menu';

import styles from './MobileHeader.module.scss';
import './MobileHeader.scss';
import '../Header/Header.scss';

const MobileHeader: FC = () => {
  const { t } = useTranslation('profilePage');
  const [confirmLogOut, setConfirmLogOut] = useState(false);
  const { onLogout } = useAuthContext();

  const accept = () => {
    onLogout();
    setConfirmLogOut(false);
  };

  const reject = () => {
    setConfirmLogOut(false);
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const isUserAuthenticated = isAuthenticated();
  const options = [
    {
      name: t('profilePage:config'),
      value: 'config',
      icon: faGear,
      color: 'main',
    },
    {
      name: t('profilePage:signOut'),
      value: 'signOut',
      icon: faSignOut,
      color: 'danger',
    },
  ];
  const logoLink = isAuthenticated()
    ? PagesPaths.PrivateHome
    : PagesPaths.PublicHome;

  const handleDropdownChange = (e: { value: string | null }, name: string) => {
    if (e.value === 'config' && name === 'userDropdown') {
      navigate(PagesPaths.Settings);
    }
    if (e.value === 'signOut') {
      setConfirmLogOut(true);
    }
    return null;
  };

  return (
    <>
      {confirmLogOut && (
        <ConfirmDialog
          visible={confirmLogOut}
          onHide={() => setConfirmLogOut(false)}
          message={t('header:logutConfirmMessage')}
          header={t('profilePage:signOut')}
          accept={accept}
          reject={reject}
          acceptLabel={t('profilePage:signOut')}
          rejectLabel={t('signUp:buttonCancel')}
          style={{ width: '40vw' }}
          breakpoints={{ '1100px': '75vw', '960px': '95vw' }}
          acceptClassName={styles.dangerButton}
          rejectClassName={styles.cancelButton}
          className={styles.signOutModalContent}
        />
      )}
      <header className={styles.mobileHeader}>
        <div>
          <button onClick={toggleMenu} type="button" aria-label="toggle menu">
            <FontAwesomeIcon
              icon={isMenuOpen ? faXmark : faBars}
              className={styles.menuIcon}
            />
          </button>
          <Link to={logoLink} className={styles.logo}>
            <WhiteLogo />
          </Link>
        </div>
        {isUserAuthenticated ? (
          <div className={styles.user}>
            <div className={styles.userIcon}>
              <FontAwesomeIcon icon={faCircleUser} />
            </div>
            <DropdownField
              id="userDropdown"
              label=""
              options={options}
              onChange={(e) => handleDropdownChange(e, 'userDropdown')}
              className="HeaderdropdownField HeaderdropdownFieldMobile"
              itemTemplate={optionTemplate}
            />
          </div>
        ) : (
          <Link to={PagesPaths.Login}>
            <FontAwesomeIcon icon={faCircleUser} />
          </Link>
        )}
      </header>
      <MobileMenu
        isMenuOpen={isMenuOpen}
        closeMenu={() => setIsMenuOpen(false)}
      />
    </>
  );
};

export default MobileHeader;
